import { useTheme } from '@mui/material';

export const IntroIcon6 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg
            className={className}
            width="48"
            height="49"
            viewBox="0 0 48 49"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 14.0179C10.8937 14.0179 10 14.9117 10 16.0179V18.5117L22.225 27.4742C23.2812 28.2492 24.7188 28.2492 25.775 27.4742L38 18.5117V16.0179C38 14.9117 37.1063 14.0179 36 14.0179H12ZM10 20.9929V32.0179C10 33.1242 10.8937 34.0179 12 34.0179H36C37.1063 34.0179 38 33.1242 38 32.0179V20.9929L26.9562 29.0867C25.1937 30.3742 22.8 30.3742 21.0437 29.0867L10 20.9929ZM8 16.0179C8 13.8117 9.79375 12.0179 12 12.0179H36C38.2062 12.0179 40 13.8117 40 16.0179V32.0179C40 34.2242 38.2062 36.0179 36 36.0179H12C9.79375 36.0179 8 34.2242 8 32.0179V16.0179Z"
                fill={primaryIconStrokeColor}
            />
        </svg>
    );
};
